export const robots = [ //not export default thats why when importing you need to do destructuring { }
  {
    id: 1,
    name: 'Luis Perez',
    username: 'Luisprz',
    email: 'luisperez@klk.com'
  },
  {
    id: 2,
    name: 'isaazz',
    username: 'isaazz',
    email: 'isaazz@isaazz.isaazz'
  },
  {
    id: 3,
    name: 'El engel',
    username: 'Engel',
    email: 'Engel@yesenia.net'
  },
  {
    id: 4,
    name: 'Roman el celdo',
    username: 'Roman',
    email: 'Roman@klk.org'
  },
  {
    id: 5,
    name: 'Chelsey Dietrich',
    username: 'Kamren',
    email: 'Lucio_Hettinger@annie.ca'
  },
  {
    id: 6,
    name: 'Robenmy',
    username: 'Robenmy',
    email: 'klk@klk.info'
  },
  {
    id: 7,
    name: 'Kurtis Weissnat',
    username: 'Elwyn.Skiles',
    email: 'Telly.Hoeger@billy.biz'
  },
  {
    id: 8,
    name: 'Nicholas Runolfsdottir V',
    username: 'Maxime_Nienow',
    email: 'Sherwood@rosamond.me'
  },
  {
    id: 9,
    name: 'Glenna Reichert',
    username: 'Delphine',
    email: 'Chaim_McDermott@dana.io'
  },
  {
    id: 10,
    name: 'Clementina DuBuque',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  }
];
